// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { useSelector } from "react-redux";

import NameOrEmail from "src/containers/user/NameOrEmail";
import { getDisableUserModalData } from "src/reducers";

import { ContentWrapper } from "./styles";

import type { UID } from "src/types";

type Props = {
  uid: UID,
};

const BodyContent = ({ uid }: Props) => {
  const { adminModal, memberModal } = useSelector(({ app }) =>
    getDisableUserModalData(app),
  );
  const showDisable = !adminModal && !memberModal;

  if (memberModal) {
    return (
      <ContentWrapper>
        {i18n.t(k.ARE_YOU_SURE_YOU_WANT_TO_MAKE)} <NameOrEmail uid={uid} />{" "}
        {i18n.t(k.ADMIN1)}
      </ContentWrapper>
    );
  } else if (adminModal) {
    return (
      <ContentWrapper>
        {i18n.t(k.ARE_YOU_SURE_YOU_WANT_TO_MAKE)} <NameOrEmail uid={uid} />{" "}
        {i18n.t(k.MEMBER2)}
      </ContentWrapper>
    );
  } else if (showDisable) {
    return (
      <ContentWrapper>
        {i18n.t(k.DISABLING_A_USER_S_ACCOUNT_WIL)}
      </ContentWrapper>
    );
  }

  return null;
};

export default BodyContent;
